module.exports = __webpack_public_path__ + "img/1.ca770c74.jpg";